module.exports.config = {
  "declarative": true,

  "render-module": {
    "name": "PieceTextRenderModule",
    "path": "front/piece-text-render.module"
  },

  "definition": {
    "type": "text",
    "name": "PieceTextDefinition",
    "group": "Basic",
    "availablePlatforms": ["web", "apps"],
    "description": "Texto",

    "fields": [
      {
        "name": "text",
        "label": "Texto",
        "placeholder": "Texto",
        "type": "richTextByDevice",
        "dropdownMode": true,
        "mandatory": true
      },
      {
        "name": "shadow",
        "label": "Texto sombreado",
        "type": "options",
        "jsonPath": "styles.shadow",
        "defaultValue": "none",
        "values": [
          {
            "value": "none",
            "label": "Sin sombras",
          },
          {
            "value": "first-text-shadow",
            "label": "Estilo 1"
          },
          {
            "value": "second-text-shadow",
            "label": "Estilo 2"
          },
          {
            "value": "third-text-shadow",
            "label": "Estilo 3"
          }
        ]
      },
      { "name": "segmentedByConfig", "label": "Segmentar por configuración", "type": "segmentedByConfig" },
      { "name": "textPadding", "label": "Padding", "type": "linkedUnits", "jsonPath": "styles.padding" },
      {
        "label": "Efectos",
        "type": "groupCollapsable",
        "flattenFields": true,
        "fields": [
          { "name": "showMarquee", "label": "Texto en movimiento", "type": "groupToggleable", "flattenFields": true, "mandatory": false,
            "fields": [
              {
                "name": "marquee",
                "type": "marquee",
                "jsonPath": "marquee"
              }
            ]
          },
          { "name": "blink", "label": "Efecto parpadeo", "type": "boolean" }
        ]
      },
      { "name": "textPositionVertical", "label": "Posición vertical", "type": "options",
        "section": "styles",
        "defaultValue": "middle",
        "values": [
          { "value": "up", "label": "Arriba" },
          { "value": "middle", "label": "Centro" },
          { "value": "down", "label": "Abajo" }
        ]
      }
    ],
    "disableStyles": [
      "shadow"
    ]
  }
};
